import React from 'react';
import language from '../../../config/es';

// Constructores de columnas de las tablas de pagos (monitor y envio de pagos).
// Se definen a nivel de modulo para no crear componentes dentro de otros componentes.

// El ancho es el minimo de la columna: si sobra espacio las columnas crecen
// hasta llenar la tabla, y el scroll horizontal aparece solo cuando no caben.
const baseColumn = (name, minWidth) => ({
  name,
  sortable: false,
  wrap: true,
  minWidth,
});

// Columna de traza; la clase depende del estado del pago
export const buildTraceColumn = (getClassName) => ({
  ...baseColumn(language.messages.monitor.lblTrace, '70px'),
  cell: (row) => (
    <span>
      <div className={getClassName(row.statusType)}>{row.trace}</div>
    </span>
  ),
});

// Columna de entidad con el numero de operacion
export const buildEntityColumn = (width, nameClassName, badgeClassName) => ({
  ...baseColumn(language.messages.monitor.lblEntity, width),
  // Nombres largos: se llevan el doble del espacio que sobra.
  grow: 2,
  cell: (row) => (
    <span>
      <div className={nameClassName}>{row.entityCode.name}</div>
      <div
        className={row.operationNumber == null ? 'noDisplay' : badgeClassName}
      >
        Op.Nro.: {row.operationNumber == null ? '' : row.operationNumber}
      </div>
    </span>
  ),
});

// Columna de datos del cliente; renderExtra agrega contenido opcional
export const buildClientColumn = (width, nameClassName, renderExtra) => ({
  ...baseColumn(language.messages.monitor.lblClientData, width),
  grow: 2,
  cell: (row) => (
    <span>
      <div className={nameClassName}>
        <i className="fa fa-user"></i>
        {row.identityClientCode.name}
      </div>
      <div className="badge bg-primary">DNI:{row.identityClientCode.ci}</div>
      {renderExtra ? renderExtra(row) : null}
    </span>
  ),
});

// Columna de canal
export const buildChannelColumn = (className) => ({
  ...baseColumn(language.messages.monitor.lblChannel, '120px'),
  cell: (row) => (
    <span>
      <div className={className}>{row.channelCode.name}</div>
    </span>
  ),
});

// Columna de total con la moneda del primer detalle
export const buildTotalColumn = (width, getClassName, zeroDecimals) => ({
  ...baseColumn(language.messages.monitor.lblTotal, width),
  right: true,
  cell: (row) => (
    <span>
      <div>
        <span className={getClassName(row.statusType)}>
          {row.total === undefined || row.total === null
            ? (0.0).toFixed(zeroDecimals)
            : row.total.operationAmount.toLocaleString('en')}
        </span>{' '}
        <span className="small-font ">
          {row.paymentDetails.length > 0
            ? row.paymentDetails[0].typeCoinCode.code
            : ''}
        </span>
      </div>
    </span>
  ),
});

// Columna de estado del pago
export const buildStateColumn = (getClassName) => ({
  ...baseColumn(language.messages.monitor.clState, '110px'),
  cell: (row) => (
    <span>
      <div className={getClassName(row.statusType)}>
        {row.statusType === null ? '' : row.statusType.name}
      </div>
    </span>
  ),
});

// Columna de fecha y hora de operacion
export const buildDateColumn = (options, optionsTime) => ({
  ...baseColumn(language.messages.monitor.lblDateOperation, '100px'),
  cell: (row) => (
    <span>
      <div className="">
        <i className="fa fa-calendar"></i>{' '}
        {new Date(row.operationDate).toLocaleDateString('es-ES', options)}
      </div>
      <div className="small-font">
        <i className="fa fa-clock-o"></i>{' '}
        {new Date(row.operationDate).toLocaleTimeString('es-ES', optionsTime)}
      </div>
    </span>
  ),
});
